<template>
  <div class="my-order" ref="container">
    <!--<navTitle title="我的订单" :isback="false"  color="#fff"></navTitle>-->
    <navTitle :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'Pesanan saya'
      " :isback="false" color="#fff"></navTitle>

    <div class="nav acea-row row-around" style="position: fixed ;z-index: 1000;top: 1rem;">
      <div class="item" :class="{ on: type === 1 }" @click="$router.replace({ path: '/order/list/1' })">
        <div>Dioperasikan</div>
      </div>
      <div class="item" :class="{ on: type === 2 }" @click="$router.replace({ path: '/order/list/2' })">
        <div>Terima</div>
      </div>

      <div class="item" :class="{ on: type === 4 }" @click="$router.replace({ path: '/order/list/4' })">
        <div>Selesai</div>
      </div>
      <div class="item" :class="{ on: type === -4 }" @click="$router.replace({ path: '/order/list/-4' })">
        <div>Dikonversikan</div>
      </div>
      <div class="item" :class="{ on: type === -3 }" @click="$router.replace({ path: '/order/list/-3' })">
        <div>Refund</div>
      </div>
    </div>

    <div class="pageContent ">

      <div class="list">
        <div class="item" v-for="order in orderList" :key="order.id" v-show="order.gameRefundBtn">
          <div class="title acea-row row-between-wrapper">
            <div class="acea-row row-middle">
              <!-- <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0" >拼团</span>
              <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0" >秒杀</span>
              <span class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0" >砍价</span>-->
              {{ order._add_time }}
            </div>
            <div class="font-color-red">{{ getStatus(order) }}</div>
          </div>
          <div @click="$router.push({ path: '/order/detail/' + order.order_id })">
            <div class="item-info acea-row row-between row-top" v-for="cart in order.cartInfo" :key="cart.id">
              <div class="pictrue">
                <img :src="
                  order.game_state == 2
                    ? cart.productInfo.up_image
                    : cart.productInfo.image
                " @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                " v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                " />
                <img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/group_detail/' + cart.combination_id
                  })
                " v-else-if="cart.combination_id > 0" />
                <img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/dargain_detail/' + cart.bargain_id
                  })
                " v-else-if="cart.bargain_id > 0" />
                <img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/seckill_detail/' + cart.seckill_id
                  })
                " v-else-if="cart.seckill_id > 0" />
              </div>
              <div class="text acea-row row-between">
                <div class="name line2">
                  {{
                  order.game_state == 2
                  ? cart.productInfo.up_store_name
                  : cart.productInfo.store_name
                  }}
                </div>
                <div class="money">
                  <template v-if="order.game_state == 2">
                    <!--如果游戏中奖 则显示奖励后价格 (这里是商品单价)-->
                    <div>
                      {{icon_moeny}}{{
                      cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.up_price
                      : cart.productInfo.up_price | MoneyFormat
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div>
                      {{icon_moeny}}{{
                      cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.price
                      : cart.productInfo.price | MoneyFormat
                      }}
                    </div>
                  </template>
                  <div>x{{ cart.cart_num }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="totalPrice">
            {{ order.cartInfo.length || 0 }} Item，Jumlah total
            <template v-if="order.game_state == 2">
              <span class="money font-color-red">{{icon_moeny}}{{ order.up_total_price | MoneyFormat}}</span>
            </template>
            <template v-else>
              <span class="money font-color-red">{{icon_moeny}}{{ order.pay_price | MoneyFormat}}</span>
            </template>
          </div>
          <div class="bottom acea-row row-right row-middle">
            <template v-if="order._status._type === 0">
              <div class="bnt cancelBnt" @click="cancelOrder(order)">Cancel</div>
              <div class="bnt bg-color-red" @click="paymentTap(order)">payment</div>
            </template>
            <template v-if="order._status._type === 1 || order._status._type === 9">
              <!-- 待发货的列表 -->
              <!-- 中奖 -->
              <template v-if="order.game_state == 2">
                <div class="bnt btn-yellow" @click="pickUpTheGoods(order)" v-if="order.pick_up_apply == 0">Mengambil
                </div>
                <div class="bnt btn-yellow" v-if="order.pick_up_apply == 1">Processing for pick up</div>
                <div class="bnt btn-blue" @click="order.gameRefundBtn && game_refund(order)" v-if="order.pick_up_apply == 0">Refund</div>
              </template>
              <!-- 没中奖 -->
              <template v-if="order.game_state == 3 && order.change_integral == 0">
                <div class="bnt btn-yellow" @click="pickUpTheGoods(order)" v-if="order.pick_up_apply == 0">Picking up
                </div>
                <div class="bnt btn-blue" @click="getIntegral(order)" v-if="order.pick_up_apply == 0">Tebus poin</div>

                <div class="bnt btn-yellow" v-if="order.pick_up_apply == 1">Processing for pick up</div>
              </template>
              <!--参与游戏 等待开奖-->
              <template v-if="order.game_state == 1">
                <CountdownGame :datatime="order.game_open_time+10"></CountdownGame>
              </template>

              <!-- 没进行游戏 -->
              <template v-if="order.game_state == 0">
                <div class="bnt btn-yellow" @click="pickUpTheGoods(order)" v-if="order.pick_up_apply == 0">Mengambil
                </div>
                <div class="bnt btn-red" @click="goGame(order)" v-if="order.pick_up_apply == 0">HOT SPOT®</div>

                <div class="bnt btn-yellow" v-if="order.pick_up_apply == 1">Processing for pick up</div>
              </template>

              <div class="bnt btn-gray" @click="$router.push({ path: '/order/detail/' + order.order_id })">Melihat
                detail</div>
            </template>
            <template v-if="order._status._type === 2">
              <div class="bnt default" @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              ">Check tracking information</div>
              <div class="bnt bg-color-red" @click="takeOrder(order)">Confirm receival</div>
            </template>

            <template v-if="order._status._type === 3">
              <div class="bnt default" @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              " v-if="order.delivery_type === 'express'">Check tracking information</div>
              <div class="bnt bg-color-red" @click="$router.push({ path: '/order/detail/' + order.order_id })">To
                evaluate</div>
            </template>
            <template v-if="order._status._type === 4">
              <div class="bnt bg-color-red" @click="$router.push({ path: '/order/detail/' + order.order_id })">view the
                order</div>
            </template>

            <template v-if="order._status._type === -2">
              <!-- 退货 -->
              <div class="bnt btn-gray" @click="$router.push({ path: '/order/detail/' + order.order_id })">Melihat
                detail</div>
            </template>
          </div>
        </div>
      </div>
      <div class="noCart" v-if="orderList.length === 0 && page > 1">
        <div class="pictrue">
          <img src="@assets/images/noOrder.png" />
        </div>
      </div>

      <!--提货单-->
      <div class="plan" v-if="showGoodsPlan">
        <div class="plan-banner">Receipt</div>
        <div class="plan-title">Melihat detail</div>
        <div class="plan-goods">
          <div class="img">
            <img v-if="selectGoods.game_state == 2" :src="selectGoods.cartInfo[0].productInfo.up_image" alt />
            <img v-else :src="selectGoods.cartInfo[0].productInfo.image" alt />
          </div>
          <div class="goods-info">
            <p class="goods-title" v-if="selectGoods.game_state == 2">
              {{ selectGoods.cartInfo[0].productInfo.up_store_name }}</p>
            <p class="goods-title" v-else>{{ selectGoods.cartInfo[0].productInfo.store_name }}</p>
            <p>x{{ selectGoods.cartInfo[0].productInfo.sales }}</p>
          </div>
        </div>
        <div class="plan-title">Recipient details</div>
        <div class="plan-form">
          <div class="form-row">
            <div class="row-name">Name</div>
            <input class="row-input" v-model="goodsForm.real_name" type="text" />
          </div>
          <div class="form-row">
            <div class="row-name">Phone</div>
            <input class="row-input" v-model="goodsForm.user_phone" type="text" />
          </div>
          <div class="form-row">
            <div class="row-name">Address</div>
            <input class="row-input" v-model="goodsForm.user_address" type="text" />
          </div>
          <!--<div class="form-row">-->
          <!--<div class="row-name">备注</div>-->
          <!--<input class="row-input" v-model="goodsForm.text" type="text">-->
          <!--</div>-->
        </div>
        <div class="plan-footer">
          <div class="plan-btn plan--btn-cancel" @click="cancelPickUp">Cancel</div>
          <div class="plan-btn plan--btn-submit" @click="submitPickUp">Confirm pick up</div>
        </div>
      </div>
      <Loading :loaded="loaded" :loading="loading"></Loading>
      <Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money"></Payment>
      <!--成功弹窗-->
      <div class="sign">
        <div class="signTip acea-row row-center-wrapper" :class="active === true ? 'on' : ''">
          <div class="signTipLight loadingpic"></div>
          <div class="signTipCon">
            <div class="state">{{uc_title}}</div>
            <div class="integral">{{uc_info}}</div>
            <div class="signTipBnt" @click="close">yakin</div>
          </div>
        </div>
        <div class="mask" @touchmove.prevent :hidden="active === false"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    pick_up,
    getOrderList,
    gameRefund,
    gameIntegral
  } from "@api/order";
  import navTitle from "@components/navTitle";
  import CountdownGame from "@components/CountdownGame";

  import {
    cancelOrderHandle,
    payOrderHandle,
    takeOrderHandle
  } from "@libs/order";
  import Loading from "@components/Loading";
  import Payment from "@components/Payment";
  import { mapGetters } from "vuex";
  import { isWeixin } from "@utils";

  const STATUS = [];

  const NAME = "MyOrder";

  export default {
    name: NAME,
    data() {
      return {
        icon_moeny: this.global.moeny,

        offlinePayStatus: 2,
        active: false, //成功弹窗
        uc_title: "success",
        uc_info: "",
        orderData: {},
        type: parseInt(this.$route.params.type) || 1,
        page: 1,
        limit: 20,
        loaded: false,
        loading: false,
        orderList: [],
        pay: false,
        selectGoods: "",
        showGoodsPlan: false,
        award: 0, //赠送积分
        goodsForm: {
          order_id: "",
          real_name: "",
          user_phone: "",
          user_address: ""
          // text:''
        },
        payType: ["yue", "weixin"],
        from: isWeixin() ? "weixin" : "weixinh5",
        canClick:true
      };
    },
    components: {
      Loading,
      Payment,
      navTitle,
      CountdownGame
    },
    computed: mapGetters(["userInfo"]),
    watch: {
      $route(n) {
        if (n.name === NAME) {
          const type = parseInt(this.$route.params.type) || 1;
          if (this.type !== type) {
            this.changeType(type);
          }
          // this.getOrderData();
        }
      },
      award(newVal, oldVal) {
        if (newVal !== oldVal) {
          // alert('触发了奖励弹窗')
        }
      }
    },
    methods: {
      close: function () {
        let that = this;
        this.active = false;
        if (this.award !== 0 && this.award) {
          setTimeout(function () {
            that.uc_title = "Alano's blessing";
            that.uc_info = `Awarded cash ${that.award} `;
            that.active = true;
            that.award = 0;
          }, 100);
        } else {
          // this.reload();
          // this.getOrderData();
        }
      },

      goGame(order) {
        switch (order.game_type) {
          case 24:
            this.$router.push({
              path: "/order/game/likeNum",
              query: {
                id: order.order_id,
                gameName: order._game_type,
                game_id: order.game_type
              }
            });
            break;
          case 28:
            this.$router.push({
              path: "/order/game/number",
              query: {
                id: order.order_id,
                gameName: order._game_type,
                game_id: order.game_type
              }
            });
            break;
        }
      },
      autoRefresh() {
        location.reload();
      },
      pickUpTheGoods(order) {
        // this.selectGoods = order;
        // this.showGoodsPlan = true;
        // this.goodsForm.order_id = order.order_id;
      },
      submitPickUp() {
        pick_up(this.goodsForm)
          .then(res => {
            // console.log('submitPickUp',res)
            this.$dialog.success(res.msg);
            this.reload();
          })
          .catch(res => {
            this.$dialog.error(res.msg);
            this.reload();
          });
      },
      cancelPickUp() {
        this.showGoodsPlan = false;
      },
      game_refund_old(order) {
        this.$dialog.loading.open("loading...");
        gameRefund(order.order_id).then(res => {
          // console.log('申请退款',res)
          this.$dialog.loading.close();
          this.uc_title = res.msg;
          this.award = res.data.award;
          this.uc_info = `Bayar ${res.data.fee}, Menerima uang tunai ${res.data.money} `;
          this.active = true;
        });
      },
      game_refund(order) {
        order.gameRefundBtn = false;
        this.$dialog.loading.open('loading...');
        gameRefund(order.order_id).then(res => {
          // console.log('申请退款',res)
          this.uc_title = res.msg
          this.award = res.data.award
          this.uc_info = `Bayar ${res.data.fee}, Menerima uang tunai ${res.data.money} `;
          this.active = true
          this.$dialog.loading.close();
        }).catch((res)=>{
          order.gameRefundBtn = true;
          this.$dialog.error(res.data.msg);
          this.$dialog.loading.close();
        })/*.finally(()=>{
          // setTimeout(()=>{
          // },3000);

          this.$dialog.loading.close();
          this.canClick=true;
          this.reload();
        });*/
      },
      //兑换积分
      getIntegral(order) {
        order.gameRefundBtn = false;
        let that = this;
        this.$dialog.loading.open("loading...");
        gameIntegral(order.order_id)
          .then(res => {
            that.$dialog.loading.close();
            that.uc_title = res.msg;
            that.award = res.data.award;
            that.uc_info = `Mendapat ${res.data.integral}  points`;
            that.active = true;
          })
          .catch(res => {
            order.gameRefundBtn = true;
            that.$dialog.error("error:" + res.msg);
            this.$dialog.loading.close();
          });
      },
      setOfflinePayStatus: function (status) {
        var that = this;
        that.offlinePayStatus = status;
        if (status === 1) {
          if (that.payType.indexOf("offline") < 0) {
            that.payType.push("offline");
          }
        }
      },
      /*getOrderData() {
        getOrderData().then(res => {
          this.orderData = res.data;
        });
      },*/
      takeOrder(order) {
        takeOrderHandle(order.order_id).finally(() => {
          this.reload();
          // this.getOrderData();
        });
      },
      reload() {
        this.showGoodsPlan = false;
        this.goodsForm = {
          order_id: "",
          real_name: "",
          user_phone: "",
          user_address: ""
        };
        this.changeType(this.type);
      },
      changeType(type) {
        this.type = type;
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
        this.getOrderList();
      },
      getOrderList() {
        if (this.loading || this.loaded) return;
        this.loading = true;
        const { page, limit, type } = this;
        getOrderList({
          page,
          limit,
          type
        }).then(res => {
          res.data.forEach(item=>{
            this.$set(item,'gameRefundBtn',true)
          })
          this.orderList = this.orderList.concat(res.data);
          this.page++;
          this.loaded = res.data.length < this.limit;
          this.loading = false;
        });
      },
      getStatus(order) {
        // if(order.game_state ==0) return '付款完成未抽奖'
        // if(order.game_state ==1) return '等待开奖'
        // else return order._game_state
        return order._game_state;
        // return STATUS[order._status._type];
      },
      cancelOrder(order) {
        cancelOrderHandle(order.order_id)
          .then(() => {
            this.orderList.splice(this.orderList.indexOf(order), 1);
          })
          .catch(() => {
            this.reload();
          });
      },
      paymentTap: function (order) {
        var that = this;
        if (
          !(
            order.combination_id > 0 ||
            order.bargain_id > 0 ||
            order.seckill_id > 0
          )
        ) {
          that.setOfflinePayStatus(order.offlinePayStatus);
        }
        this.pay = true;
        this.toPay = type => {
          payOrderHandle(order.order_id, type, that.from)
            .then(() => {
              const type = parseInt(this.$route.params.type) || 0;
              that.changeType(type);
              // that.getOrderData();
            })
            .catch(res => {
              if (res.status === "WECHAT_H5_PAY")
                return that.$router.push({
                  path: "/order/status/" + order.order_id + "/5"
                });
              const type = parseInt(that.$route.params.type) || 0;
              that.changeType(type);
              // that.getOrderData();
            });
        };
      },
      toPay() { }
    },
    mounted() {
      // this.getOrderData();
      this.getOrderList();
      this.$scroll(this.$refs.container, () => {
        !this.loading && this.getOrderList();
      });
    }
  };
</script>

<style scoped>
  .nav {
    width: 7.5rem;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  .noCart {
    margin-top: 3rem;
    padding-top: 0.1rem;
  }

  .noCart .pictrue {
    width: 4rem;
    height: 3rem;
    margin: 0.7rem auto 0.5rem auto;
  }

  .noCart .pictrue img {
    width: 100%;
    height: 100%;
  }

  .btn-red {
    border: 1px solid #da2d2d;
    color: #da2d2d;
  }

  .btn-blue {
    border: 1px solid #00c3f9;
    color: #00c3f9;
  }

  .btn-gray {
    border: 1px solid #999999;
    color: #999999;
  }

  .btn-yellow {
    border: 1px solid #fcbb01;
    color: #fcbb01;
  }

  /*提货单*/
  .plan {
    width: 6rem;
    height: 8.5rem;
    background: #fff;
    position: fixed;
    z-index: 1000;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto auto;
    border-radius: 0.3rem;
    overflow: hidden;
    box-shadow: 0px 0px 10px #ccc;
  }

  .plan-banner {
    width: 100%;
    height: 1rem;
    background: url("../../assets/images/tihuo.png") no-repeat;
    background-size: 100% 100%;
    line-height: 1rem;
    text-align: center;
    color: #333;
  }

  .plan-title {
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    padding: 0 0.3rem;
    box-sizing: border-box;
  }

  .plan-goods {
    width: 100%;
    display: flex;
    padding: 0rem 0.3rem 0.3rem 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px dashed #eee;
  }

  .plan-goods .img {
    width: 1rem;
    height: 1rem;
    background: #7a7a7a;
  }

  .plan-goods .img img {
    width: 100%;
    height: 100%;
  }

  .plan-goods .goods-info {
    flex: 1;
    padding-left: 0.15rem;
    box-sizing: border-box;
  }

  .plan-goods .goods-info .goods-title {
    font-size: 0.3rem;
    width: 100%;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .plan-form {
    width: 100%;
    padding: 0 0.3rem;
    box-sizing: border-box;
  }

  .plan-form .form-row {
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    display: flex;
    margin-bottom: 0.3rem;
  }

  .plan-form .form-row .row-name {
    width: 1rem;
    height: 0.6rem;
    color: #333;
  }

  .plan-form .form-row .row-input {
    flex: 1;
    height: 0.6rem;
    color: #333;
    border: 1px solid #eee;
    border-radius: 0.15rem;
    margin-left: 0.3rem;
    padding: 0.15rem;
  }

  .plan-footer {
    position: absolute;
    width: 100%;
    height: 1rem;
    bottom: 0px;
    left: 0px;
    display: flex;
    justify-content: space-between;
    padding: 0.2rem 0.3rem 0rem 0.3rem;
    box-sizing: border-box;
  }

  .plan-btn {
    width: 2.4rem;
    height: 0.6rem;
    line-height: 0.6rem;
    text-align: center;
    border-radius: 0.25rem;
  }

  .plan--btn-cancel {
    background: #fff;
    color: #666;
    border: 1px solid #999;
  }

  .plan--btn-submit {
    background: #00c3f9;
    color: #fff;
    border: 1px solid #00c3f9;
  }
</style>